import type { definitions } from '@luxuryescapes/contract-svc-lab-v2'
import type { LabV2Ui } from './evaluation'
import { triggerPointForPath } from './headerBanners'

type PopupUi = Extract<LabV2Ui, { type: 'popup' }>

export type LabV2PopupFrequency = 'once_per_session' | 'once_per_7_days' | 'once'

export type LabV2Popup = {
  id: number
  triggerPoints: PopupUi['trigger_points']
  displayFrequency: LabV2PopupFrequency
  style: definitions['PopupPayload']['style']
  content: definitions['PopupContent']
}

const PERMANENT_DISMISSAL_END_DATE = '9999-12-31T23:59:59.999Z'

export function popupsFromUis(uis: Array<LabV2Ui> | undefined): Array<LabV2Popup> {
  if (!uis) {
    return []
  }

  const popups: Array<LabV2Popup> = []
  for (const ui of uis) {
    if (ui.type !== 'popup') {
      continue
    }
    popups.push({
      id: ui.id,
      triggerPoints: ui.trigger_points,
      displayFrequency: displayFrequency(ui.display_frequency),
      style: ui.payload.style,
      content: ui.payload.content,
    })
  }
  return popups
}

/** First qualifying popup for this page, in evaluate order. */
export function popupForPage(
  popups: Array<LabV2Popup>,
  path: string,
  regionCode?: string,
): LabV2Popup | undefined {
  const triggerPoint = triggerPointForPath(path, regionCode)
  if (!triggerPoint) {
    return undefined
  }

  return popups.find(popup => popup.triggerPoints.includes(triggerPoint))
}

/** When a seen popup stays hidden. */
export function popupSeenUntil(frequency: LabV2PopupFrequency, now: Date): string {
  if (frequency === 'once') {
    return PERMANENT_DISMISSAL_END_DATE
  }
  const date = new Date(now)
  if (frequency === 'once_per_7_days') {
    date.setDate(date.getDate() + 7)
    date.setHours(0, 0, 0, 0)
    return date.toISOString()
  }
  date.setHours(24, 0, 0, 0)
  return date.toISOString()
}

function displayFrequency(frequency: PopupUi['display_frequency']): LabV2PopupFrequency {
  if (frequency === 'once' || frequency === 'once_per_7_days' || frequency === 'once_per_session') {
    return frequency
  }
  return 'once_per_session'
}
